<template>
  <div>
    <TitleWithButton
      title="Файлы"
      button-text="Добавить"
      creatable
      class="mt-6 mb-4 headline"
      @create="$refs.input.click()"
    />

    <BTableCommon
      :list="list"
      :items-per-page-options="itemsPerPageOptions"
      :loading="isLoading"
      type="base-event-files"
      @action:delete="onDelete"
    />

    <input
      v-show="false"
      ref="input"
      type="file"
      multiple
      @input="onCreateMultiple($event.target.files)"
    >
  </div>
</template>

<script>
import { RoadmapBaseEventsApi } from '@/api/resources'
import { DEFAULT_PER_PAGE_OPTIONS } from '@/helpers/enums/params'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'


export default {
  name: 'RoadmapBaseEventFilesList',
  components: {
    BTableCommon,
    TitleWithButton,
  },
  model: {
    prop: 'list',
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    eventId: {
      type: [Number, String],
      required: true,
    },
    roadmapId: {
      type: [Number, String],
      required: true,
    },
    directionId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      itemsPerPageOptions: [5, ...DEFAULT_PER_PAGE_OPTIONS],
      defaultParams: {
        roadmap_id: this.roadmapId,
        direction_id: this.directionId,
        event_id: this.eventId,
      },
    }
  },
  methods: {
    async onCreateMultiple(files) {
      this.isLoading = true

      await [...files].reduce((promise, file) => (
        promise.then(() => this.onCreate(file))
      ), Promise.resolve())

      this.$emit('created')
      this.isLoading = false
    },
    async onCreate(file) {
      const api = new RoadmapBaseEventsApi()
      const params = this.defaultParams

      try {
        await api.uploadFile(params, file)
      } catch (e) {
        this.$notice.errors(e)
      }
    },
    async onDelete(data, cb) {
      const unwatch = cb?.()

      const api = new RoadmapBaseEventsApi()
      const params = {
        ...this.defaultParams,
        file_id: data.id,
      }

      try {
        await api.deleteFile(params)
        const list = this.list.filter((_) => _.id !== data.id)
        this.$emit('input', list)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
  },
}
</script>
